import React, { useEffect, useState } from "react";
import { Button, MenuItem, InputGroup, Intent, Icon } from "@blueprintjs/core";
import { DateRangePicker } from "@blueprintjs/datetime";
import styles from "./FilterToolbar.module.scss";

function FilterItem({ filter, filters, onAddFilter }) {
  const [selection, setSelection] = useState();
  const [search, setSearch] = useState("");

  useEffect(() => {
    setSelection(filters[filter.key]);
  }, [filter.key, filters]);

  function filterItems(item) {
    const normalizedFilter = search.trim().toLowerCase();
    const normalizedLabel = item.label.trim().toLowerCase();
    return normalizedLabel.indexOf(normalizedFilter) > -1;
  }

  return (
    <div>
      {filter.filter && (
        <InputGroup
          leftIcon="search"
          placeholder="Filter..."
          className={styles.search}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      )}

      {filter.type === "menu" && (
        <div className={styles.menuItems}>
          {filter.options.filter(filterItems).map((option) => (
            <MenuItem
              key={option.key}
              text={option.label}
              active={selection && selection.key === option.key}
              labelElement={
                selection &&
                selection.key === option.key && <Icon icon="tick" />
              }
              onClick={(e) => {
                e.preventDefault();
                setSelection(
                  selection && selection.key === option.key ? undefined : option
                );
              }}
            />
          ))}
        </div>
      )}

      {filter.type === "menu" &&
        filter.options.filter(filterItems).length === 0 && (
          <MenuItem disabled text="No results." />
        )}

      {filter.type === "dateRange" && (
        <DateRangePicker
          singleMonthOnly
          shortcuts
          allowSingleDayRange={false}
          value={selection}
          onShortcutChange={({ dateRange }) => onAddFilter(dateRange)}
          onChange={(e) => setSelection(e)}
        />
      )}

      <Button
        intent={Intent.PRIMARY}
        text="Add Filter"
        disabled={
          !selection ||
          (filter.type === "dateRange" && (!selection[0] || !selection[1]))
        }
        className={styles.addFilterButton}
        onClick={() => onAddFilter(selection)}
        fill
      />
    </div>
  );
}

export default FilterItem;
